module.exports = __webpack_public_path__ + "img/slider4.926c7e98.jpg";